import React, { useCallback, useEffect, useRef, useState } from "react";
import ModelSelector from "../component/ModelSelector";
import { models } from "../data/models";
import useCanvas, {
  HEIGHT,
  SHOW_HEIGHT,
  SHOW_WIDTH,
  WIDTH,
} from "../hooks/useCanvas";
import "../styles/PredictCanvas.css";
import Canvas, { CANVAS_MODE } from "./Canvas";
import { AI_SERVER_PATH, debounce } from "../utils/utils";
import TeachedLabels from "../component/TeachedLabels";
const PREDICT_PATH = AI_SERVER_PATH + "/predict";

const PredictCanvas = () => {
  const {
    mainCanvasRef,
    hiddenCanvasRef,
    clearCanvas,
    startDrawing,
    draw,
    stopDrawing,
    config,
  } = useCanvas();
  const [model, setModel] = useState(models[0]);
  const [result, setResult] = useState("");
  const debouncedSendPredict = useRef(null);

  const { WIDTH, HEIGHT } = config.Value;

  console.log("Rerender predict");

  useEffect(() => {
    clearCanvas();
    config.update("STROKE_WIDTH", model.strokeWidth);
    console.log("Changed model " + model.name);
  }, [model]);

  useEffect(() => {
    const debouncedFunction = debounce(() => sendPredict(model), 100);
    debouncedSendPredict.current = debouncedFunction;
  }, [model]);

  const handleStopDrawing = useCallback(
    (e) => {
      stopDrawing(e);
      if (debouncedSendPredict.current) {
        debouncedSendPredict.current();
      }
    },
    [stopDrawing]
  );

  async function sendPredict(model) {
    const hiddenCtx = hiddenCanvasRef.current.getContext("2d");
    hiddenCtx.drawImage(mainCanvasRef.current, 0, 0, WIDTH, HEIGHT);
    const dataURL = hiddenCanvasRef.current.toDataURL("image/png");
    const base64Image = dataURL.split(",")[1];
    try {
      const response = await fetch(PREDICT_PATH + model.endpoint, {
        method: "POST",
        body: JSON.stringify({ imageData: base64Image }),
        headers: { "Content-Type": "application/json" },
      });

      if (response.ok) {
        const result = await response.json();
        setResult(result?.predictResult);
      } else {
        console.error("Error predicting image:", response.statusText);
      }
    } catch {}
  }

  return (
    <div className="predict-container">
      <form className="predict-form" onSubmit={(e) => e.preventDefault()}>
        <ModelSelector model={model} setModel={setModel} />
        <div className="predict-input">
          <span>予測 :</span>
          <label>{result || "..."}</label>
        </div>
        <Canvas
          mainCanvasRef={mainCanvasRef}
          hiddenCanvasRef={hiddenCanvasRef}
          startDrawing={startDrawing}
          draw={draw}
          stopDrawing={handleStopDrawing}
          mode={CANVAS_MODE.PREDICT}
          config={config.Value}
        />
        <div className="flex justify-end">
          <button
            type="button"
            onClick={clearCanvas}
            className="predict-button"
          >
            Clear
          </button>
        </div>
      </form>
      <div className="flex justify-end">
        <TeachedLabels title={model.name} items={model.teachedList} />
      </div>
    </div>
  );
};

export default PredictCanvas;
